import React, { ReactNode, useCallback, useRef, memo } from 'react';
import { Fade } from '@material-ui/core';
import { isEmpty } from 'lodash';
import { ImagemBlobParaBase64 } from 'utils';
import AddAPhotoRoundedIcon from '@material-ui/icons/AddAPhotoRounded';
import { BotaoTransparente, useNotificacoes } from 'components';
import { useStyles } from './cardapio-header-capa-styles';
import { atualizarTemaCapa } from 'api/cardapio/mutations/tema/put-tema-capa';
import { useMasterApi } from '../../../hooks';
import { usePostImagemBase64 } from 'api/cardapio/queries/imagem/post-imagem';
import { imagemForUpload } from 'utils/imagem-for-upload';

export interface CardapioHeaderCapaProps {
  capaUrl?: string;
  height: number | string;
  children?: ReactNode;
  somenteLeitura?: boolean;
  empresaId: string;
  quandoUmaNovaCapaForSelecionada?: (args: { capa: string }) => any;
}

const CardapioHeaderCapaComp = ({
  capaUrl,
  somenteLeitura,
  children,
  height,
  empresaId,
  quandoUmaNovaCapaForSelecionada,
}: CardapioHeaderCapaProps) => {
  const inputFileRef = useRef<HTMLInputElement>(null);
  const { showErrorMessage, showSuccessMessage } = useNotificacoes();
  const { postImagemBase64 } = usePostImagemBase64()

  const { operacoes } = useMasterApi(empresaId);

  const salvarCapa = useCallback(async (capa: string) => {
    try {
      const imgUpload = imagemForUpload(capa);
      const res = await postImagemBase64(imgUpload, 'cardapio/capa/', `${empresaId}`, false)
      if (res.erro) throw res.erro
      const resultado = res.resultado?.data?.data?.url_blob +
        '?timestamp=' +
        new Date().getTime();
      await atualizarTemaCapa.execute({ empresaId: empresaId, imagem: { imagemBase64: resultado } });

      showSuccessMessage('Capa atualizada com sucesso.');
      operacoes.atualizarCadastroEmpresa.executar()
      if (quandoUmaNovaCapaForSelecionada) {
        quandoUmaNovaCapaForSelecionada({
          capa,
        });
      }
    }
    catch (error: any) {
      showErrorMessage('Erro ao tentar atualizar a capa. Verifique a sua conexão e tente novamente. Detalhe: ' + error.message)
    }
  }, [empresaId, operacoes.atualizarCadastroEmpresa, postImagemBase64, quandoUmaNovaCapaForSelecionada, showErrorMessage, showSuccessMessage])

  const atualizarFotoDeCapa = useCallback(() => {
    inputFileRef?.current?.click();
  }, []);

  const uploadCapa = useCallback(
    async (event: React.ChangeEvent<HTMLInputElement>) => {
      if (isEmpty(event?.target?.files)) {
        return;
      }

      const file = event?.target?.files![0];
      const capa = await ImagemBlobParaBase64(file);

      await salvarCapa(capa);
    },
    [salvarCapa],
  );

  const classes = useStyles({ capaUrl, height });

  return (
    <div className={classes.conteudo}>
      <Fade in={somenteLeitura === false} appear={false}>
        <div className={classes.action}>
          <input
            ref={inputFileRef}
            multiple={false}
            type="file"
            value={''}
            accept="image/*"
            hidden
            onChange={uploadCapa}
          />
          <BotaoTransparente tipo="button" size="small" onClick={atualizarFotoDeCapa}>
            <AddAPhotoRoundedIcon fontSize="small" className={classes.marginRight} />
            {capaUrl ? 'Alterar Capa' : 'Adicionar Capa'}
          </BotaoTransparente>
        </div>
      </Fade>
      <div className={classes.conteudoFilho}>{children}</div>
    </div>
  );
};
export const CardapioHeaderCapa = memo(CardapioHeaderCapaComp);
